














import {forumApi} from '@/api/ForumApi';
import {Component, Prop, Vue} from 'vue-property-decorator';
import UserUnconfirmedReportsLink from '@/components/common/UserUnconfirmedReportsLink.vue';
import UserRatingLink from '@/components/common/UserRatingLink.vue';

@Component({
  components: {
    UserUnconfirmedReportsLink,
    UserRatingLink,
  },
})
export default class UserLinks extends Vue {
  @Prop() private userId!: number;
  @Prop() private username!: string;
  @Prop() private lang!: string;
  @Prop() private hasUnconfirmedReports!: boolean;
  @Prop() private isCurrentUser!: boolean;

  get forumProfileLink() {
    return forumApi.getUserProfileUrl(this.userId);
  }
}
